unit PrepareOperationListScreenType;

interface

uses
  PrepareOperationItemListType, SpecialismListType;

type
  TPrepareOperationListScreenType = class
  private
    fPrepareOperationItemList: TPrepareOperationItemListType;
    fSpecialismList: TSpecialismListType;
  public
    property PrepareOperationItemList: TPrepareOperationItemListType read fPrepareOperationItemList;
    property SpecialismList: TSpecialismListType read fSpecialismList;
  end;

implementation

end.
